import React from "react";
import { Spinner } from "flowbite-react";
import { FiSearch } from "react-icons/fi";

const LoadingAnaliseIA = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-10 rounded-xl shadow-lg border border-slate-700">
      <div className="relative mb-6">
        <div className="w-24 h-24 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <FiSearch className="text-blue-400 w-9 h-9 animate-pulse" />
        </div>
      </div>
      <h2 className="text-white text-xl font-semibold mb-2">
        Gerando Análise de Crédito Avançada...
      </h2>
      <p className="text-slate-300 text-sm text-center">
        Estamos processando os dados financeiros,
        <br />
        identificando riscos e consolidando as recomendações.
      </p>
    </div>
  );
};

export default LoadingAnaliseIA;
